<!--
NOTE: select element id is set in soho-dropdown.component.ts via setting the name attribute
todo: if there are issues with id then check the soho-dropdown.component to verify it's still
setting the id from the name attribute.
-->


@if (!isCompoundFieldMember && showLabel) {
  <label
    attr.for="{{id}}"
    soho-label
    [required]="required$ | async"
    lm-label
    [layoutField] = "field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    (click)="onCompoundFieldClickEvent($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
}

<!--
<ng-container [ngSwitch]="formType">
  <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
    -->

    @if (formType === formDisplayType.SEARCH_FORM) {
      @if (isCompoundFieldMember) {
        <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
        @if (lmParagraphLayoutInfo.previewMode) {
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="NormalMode"></ng-container>
        }
        <!-- On a search form, just a compound field member NOT in the preview -->
        <ng-template #NormalMode>
          <div
            (focusin)="onFieldFocus($event)"
            (focusout)="onFieldBlur($event)">
            @switch (displayType) {
              @case (layoutDisplayType.USER_DEFINED) {
                <!--          [showSelectAll]="showSelectAll"-->
                <select
                  [ngClass]="fieldClassesString"
                  name="{{id}}"
                  attr.name="{{id}}"
                  [attributes]="fieldIdAttributes"
                  [attr.bindId]="bindId"
                  [readonly]="(readOnly$ | async)"
                  [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
                  [(ngModel)]="modelField.value"
                  soho-dropdown
                  [source]="source"
                  [reload]="userDefinedReloadType"
                  (change)="onChanged($event)"
                  soho-busyindicator
                  blockUI="true"
                  displayDelay="0"
                  soho-alert
                  >
                  @for (item of modelField.states; track trackByValue($index, item)) {
                    <option selected="{{item.selected}}" [value]="item.value">{{item.label}}</option>
                  }
                </select>
              }

              @case (layoutDisplayType.PLAIN) {
                <select
                  [ngClass]="fieldClassesString"
                  name="{{id}}"
                  attr.name="{{id}}"
                  [attributes]="fieldIdAttributes"
                  [attr.bindId]="bindId"
                  [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
                  [readonly]="(readOnly$ | async)"
                  [(ngModel)]="modelField.value"
                  soho-alert
                  soho-dropdown
                  multiple
                  [compareWith]="compareWithFn"
                  [moveSelected]="'all'"
                  [showSelectAll]="true"
                  [closeOnSelect]="false"
                  (change)="onChanged($event)"
                  (click)="onChanged($event)"
                  >
                  @for (item of staticDisplayValues; track trackByValue($index, item)) {
                    <option selected={{item.selected}} [value]="item.value">{{item.label}}</option>
                  }
                </select>
              }

              @case (layoutDisplayType.BOOLEAN) {
                <select
                  [ngClass]="fieldClassesString"
                  name="{{id}}"
                  attr.name="{{id}}"
                  [attributes]="fieldIdAttributes"
                  [attr.bindId]="bindId"
                  [readonly]="(readOnly$ | async)"
                  [(ngModel)]="modelField.value"
                  soho-alert
                  soho-dropdown
                  (change)="onChanged($event)"
                  >
                  @for (item of modelField.states; track trackByValue($index, item)) {
                    <option [value]="item.value">{{item.label}}</option>
                  }
                </select>
              }
            }

            <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
            <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
          </div>
        </ng-template>
      } @else {
        @switch (displayType) {
          @case (layoutDisplayType.USER_DEFINED) {
            <!--        [showSelectAll]="showSelectAll"-->
            @if (showUserDefinedAsMulti) {
              <select
                [ngClass]="fieldClassesString"
                name="{{id}}"
                attr.name="{{id}}"
                [attributes]="fieldIdAttributes"
                [attr.bindId]="bindId"
                [(ngModel)]="modelField.value"
                soho-alert
                soho-dropdown
                multiple
                [compareWith]="compareWithFn"
                [moveSelected]="'all'"
                [showSelectAll]="true"
                [closeOnSelect]="false"
                [source]="source"
                [reload]="userDefinedReloadType"
                (change)="onChanged($event)"
                soho-busyindicator
                blockUI="true"
                displayDelay="0"
                >
                @for (item of modelField.states; track trackByValue($index, item)) {
                  <option [selected]="item.selected" [value]="item.value">{{item.label}}</option>
                }
              </select>
            } @else {
              <select
                [ngClass]="fieldClassesString"
                name="{{id}}"
                attr.name="{{id}}"
                [attributes]="fieldIdAttributes"
                [attr.bindId]="bindId"
                [(ngModel)]="modelField.value"
                soho-alert
                soho-dropdown
                [source]="source"
                [reload]="userDefinedReloadType"
                (change)="onChanged($event)"
                soho-busyindicator
                blockUI="true"
                displayDelay="0"
                >
                @for (item of modelField.states; track trackByValue($index, item)) {
                  <option [selected]="item.selected" [value]="item.value">{{item.label}}</option>
                }
              </select>
            }
          }

          @case (layoutDisplayType.PLAIN) {
            <select
              [ngClass]="fieldClassesString"
              name="{{id}}"
              attr.name="{{id}}"
              [attributes]="fieldIdAttributes"
              [attr.bindId]="bindId"
              [(ngModel)]="modelField.value"
              soho-alert
              soho-dropdown
              multiple
              [compareWith]="compareWithFn"
              [moveSelected]="'all'"
              [showSelectAll]="true"
              [closeOnSelect]="false"
              (change)="onChanged($event)"
              (click)="onChanged($event)"
              >
              @for (item of staticDisplayValues; track trackByValue($index, item)) {
                <option [selected]="item.selected" [value]="item.value" >{{item.label}}</option>
              }
            </select>
          }

          <!-- multi select -->
          @case (layoutDisplayType.MULTI) {
            <select
              [ngClass]="fieldClassesString"
              name="{{id}}"
              attr.name="{{id}}"
              [attributes]="fieldIdAttributes"
              [attr.bindId]="bindId"
              [(ngModel)]="modelField.value"
              soho-alert
              soho-dropdown
              multiple
              [compareWith]="compareWithFn"
              [maxSelected]="maxSelected"
              [source]="source"
              moveSelected="all"
              [closeOnSelect]="false"
              showSearchUnderSelected="true"
              reload="{{userDefinedReloadType}}"
              (change)="onChanged($event)"
              soho-busyindicator
              blockUI="true"
              displayDelay="0"
              >
              @for (item of modelField.states; track trackByValue($index, item)) {
                <option [selected]="item.selected" disabled="{{item.disabled}}" [value]="item.value">{{item.label}}</option>
              }
            </select>
          }

          @case (layoutDisplayType.BOOLEAN) {
            <select
              [ngClass]="fieldClassesString"
              name="{{id}}"
              attr.name="{{id}}"
              [attributes]="fieldIdAttributes"
              [attr.bindId]="bindId"
              [(ngModel)]="modelField.value"
              soho-alert
              soho-dropdown
              noSearch
              (change)="onChanged($event)"
              >
              @for (item of modelField.states; track trackByValue($index, item)) {
                <option [value]="item.value">{{item.label}}</option>
              }
            </select>
          }
        }
          @if (layoutInfo.isAdHoc !== null && layoutInfo.isAdHoc) {
            <button
              id="AdHocRemove"
              class="lm-compound-field-dialog-button lm-adhoc-remove"
              soho-button="icon"
              [icon]="'close-small'"
              soho-tooltip
              [content]="'Remove Field'"
              (click)="removeAdHocField($event)"
            ></button>
          }
      }
    } @else {
      <!-- Not on a search form -->
      <div
      [ngClass]="{
        'disabled-member-field': disabledMemberField,
        'parent-is-compound-field': isCompoundFieldMember,
        'lm-is-display-as-text': displayAsText}"
      lm-field-options
      [hasContextMenu]="insertContextMenu"
      [dataEntryMode]="dataEntryMode"
      [isMemberField]="isCompoundFieldMember"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldAutomationId]="fieldAutomationId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      [disableFieldOptions]="disableFieldOptions"
      lm-layout-util
      [hideWhiteSpace]="shouldHideWhiteSpace"
      soho-tooltip
      [popover]="true"
      [title]="popoverTitle"
      [placement]="'right'"
      [trigger]="'click'"
      (focus)="onFocus($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      (contextmenu)="onContextMenu($event)">
    @if (displayType === layoutDisplayType.PLAIN || displayType === layoutDisplayType.USER_DEFINED || displayType === layoutDisplayType.MULTI) {
    }
    @switch (displayType) {
      @case (layoutDisplayType.PLAIN) {
        <!-- single select static -->
        @if (showDropDownDirtyIndicator) {
          <span class="icon-dirty lm-compound-member-field-dirty"></span>
        }
        <select
            [ngClass]="fieldClassesString"
            name="{{id}}"
            attr.name="{{id}}"
            [attributes]="fieldIdAttributes"
            [attr.bindId]="bindId"
            [readonly]="(readOnly$ | async)"
            [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
            [ngModel]="modelField.valueChanged | async"
            (ngModelChange)="onModelChanged($event)"
            soho-dropdown
            (change)="onChanged($event)"
            (blur)="onBlur($event)"
            soho-alert
            soho-trackdirty
            [searchForm]="onSearchForm"
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
        >
          <option *ngFor="let item of staticDisplayValues; trackBy: trackByValue" [value]="item.value" [disabled]="item.disabled">{{item.label}}</option>
        </select>
      }

          <!-- single select user defined -->
          @case (layoutDisplayType.USER_DEFINED) {
            <select
              [ngClass]="fieldClassesString"
              name="{{id}}"
              attr.name="{{id}}"
              [attributes]="fieldIdAttributes"
              [attr.bindId]="bindId"
              [readonly]="(readOnly$ | async)"
              [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
              [ngModel]="modelField.valueChanged | async"
              (ngModelChange)="onModelChanged($event)"
              soho-dropdown
              [reload]="userDefinedReloadType"
              [source]="source"
              (change)="onChanged($event)"
              soho-alert
              soho-trackdirty
              [searchForm]="onSearchForm"
              (dirty)="onDirty($event)"
              (pristine)="onPristine($event)"
              (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"
              soho-busyindicator
              blockUI="true"
              displayDelay="0"
              >
              @for (item of modelField.states; track trackByValue($index, item)) {
                <option [selected]="item.selected" disabled="{{item.disabled}}" [value]="item.value">{{item.label}}</option>
              }
            </select>
          }

          <!-- multi select -->
          @case (layoutDisplayType.MULTI) {
            <select
              [ngClass]="fieldClassesString"
              [class.keyMultiSelect]="modelField.isKeyFieldMultiselect"
              name="{{id}}"
              attr.name="{{id}}"
              [attributes]="fieldIdAttributes"
              [attr.bindId]="bindId"
              [readonly]="(readOnly$ | async)"
              [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
              [ngModel]="modelField.valueChanged | async"
              (ngModelChange)="onModelChanged($event)"
              soho-dropdown
              [multiple]="true"
              [maxSelected]="maxSelected"
              [source]="source"
              moveSelected="all"
              [closeOnSelect]="false"
              showSearchUnderSelected="true"
              reload="{{userDefinedReloadType}}"
              (change)="onChanged($event)"
              soho-alert
              soho-trackdirty
              [searchForm]="onSearchForm"
              (dirty)="onDirty($event)"
              (pristine)="onPristine($event)"
              (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"
              soho-busyindicator
              blockUI="true"
              displayDelay="0"
              >
              @for (item of modelField.states; track trackByValue(i, item); let i = $index) {
                <option id="i" [selected]="item.selected" [value]="item.value" disabled="{{item.disabled}}">{{item.label}}</option>
              }
            </select>
          }

          <!-- tag -->
          @case (layoutDisplayType.TAG) {
            <div
              class="tag-container"
              soho-alert
              lm-field-style
              [fieldStyle]="layoutObject?.fieldStyle"
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
              >
              <span
                attr.id="{{id}}"
                class="tag is-dismissible"
              [ngClass]="{
                'lm-compound-text': isCompoundFieldMember,
                'lm-text-data ': !isCompoundFieldMember,
                'is-active': isFieldTagFocused,
                'is-focused': isFieldTagFocused,
                'hide-focus': !isFieldTagFocused
                }"
                [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                [ngStyle]="{'color': '#FFFFFF', 'outline': 'none'}"
                soho-alert
                lm-field-style
                [fieldStyle]="tagStyle?.style"
                [isTag]="true"
                [recalculateStyles]="triggerValueChange | async"
                (focus)="onTagFocus()"
                (blur)="onTagBlur()"
              >{{modelField.valueChanged | async | stateAsText:modelField.states:true}}</span>
            </div>
          }

          <!-- text -->
          @case (layoutDisplayType.TEXT) {
            <p
              attr.id="{{id}}"
              class="hide-white-space"
              [ngClass]="{'lm-compound-text': isCompoundFieldMember, 'lm-text-data ': !isCompoundFieldMember}"
              [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
              [ngStyle]="{'display': 'inline-block'}"
              soho-alert
              lm-field-style
              [fieldStyle]="layoutObject?.fieldStyle"
              [recalculateStyles]="triggerValueChange | async"
            >{{modelField.valueChanged | async | stateAsText:modelField.states}}</p>
          }
        }

        <!-- Handle the compound field member display label/value not focused in compact format on a form -->
        @if (isCompoundFieldMember) {
          @if (lmParagraphLayoutInfo?.previewMode) {
            <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
          }
        }

      </div>
    }

    <ng-template #CompoundPlaceHolderDisplayNormalMode>
      @if (isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField)) {
        <p
          [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
          attr.id="{{id}}-text"
          [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
          class="lm-compound-text"
          [ngClass]="{'is-placeholder preview-placeholder': true, 'input-style': !(readOnly$ | async)}"
          [ngStyle]="{'display':  showField ? 'none' : 'inline-block'}"
          soho-alert
          (focus)="onFocus($event)"
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
      }
    </ng-template>

    <ng-template #CompoundPlaceHolderDisplayPreviewMode>
      @if (!(isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField))) {
        <p
          attr.id="{{id}}-text"
          class="lm-compound-text hide-white-space"
          [ngStyle]="{'display': 'inline-block'}"
          soho-alert
        >{{modelField.valueChanged | async | stateAsText:modelField.states}}</p>
      } @else {
        <p
          attr.id="{{id}}-text"
          class="lm-compound-text input-style is-placeholder preview-placeholder"
          [ngStyle]="{'padding-top': isPreviewCompoundMember? '0' : '10px'}"
          soho-alert
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
      }
    </ng-template>

    <ng-template #mouseOverTextTemplate>
      @if (layoutObject.mouseOverText) {
        <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
      }
    </ng-template>

    <span [id]="fieldDescriptionId + '-dropdown'" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
    @if (errorLiveMessage.liveMessage) {
      <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
    }
